import React from 'react';

function FormFooter({ title }: { title: string }) {
  return (
    <div className="form-footer">
      <h3>{title}</h3>
    </div>
  );
}

export default FormFooter;
